var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployesssTotalNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Unique_Icon_ID",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105.65,
    height: 52.164,
    viewBox: "0 0 105.65 52.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Unique_Clip_Path_ID"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Unique_Rectangle_ID",
    width: 105.65,
    height: 52.164,
    fill: "#1d3943"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unique_Group_ID",
    transform: "translate(0 0)",
    clipPath: "url(#Unique_Clip_Path_ID)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M119.3,31.392a5.011,5.011,0,0,1-6.142,0,5.455,5.455,0,0,0-1.16.518,7.853,7.853,0,0,1,.095,1.158v6.2a3.572,3.572,0,0,1-2.612,3.43,1.926,1.926,0,0,0,1.722,1.073h.475V55.318a1.877,1.877,0,0,0,1.877,1.876h.331a1.877,1.877,0,0,0,1.877-1.876V47.158a.469.469,0,0,1,.938,0v8.159a1.876,1.876,0,0,0,1.876,1.876h.326a1.876,1.876,0,0,0,1.876-1.876V43.775h.481a1.933,1.933,0,0,0,1.933-1.933V36.667a5.521,5.521,0,0,0-3.893-5.275",
    transform: "translate(-17.544 -5.03)",
    fill: "#1d3943"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployesssTotalNumber);
export default __webpack_public_path__ + "static/media/employesss_total_number.c6fec690ac6513c5f877ffcf51e62a1a.svg";
export { ForwardRef as ReactComponent };